import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { CheckinCheckoutHelper } from "../../../utilities/CheckinCheckoutHelper";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { ArrowCircleUpLeft20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/ArrowCircleUpLeft20Regular";

export function useMenuItem_Checkin(
    selectedItems: any[],
    waitFor: boolean,
    setIsPublish: (isPublish: boolean) => void,
    setShowCheckinDialog: (showCheckinDialog: boolean) => void,
    isInOneDrive: boolean
) {
    const languageStrings = React.useContext(LanguageContext);
    const userAccount = useSelector((state: RootState) => state.user.account);

    const menuItem_Checkin = React.useMemo(() => {

        const areAllItemsCheckedOutByCurrentUser = () => {
            if (!selectedItems.every(item => Array.isArray(item.CheckoutUser) && item.CheckoutUser.length > 0)) {
                return false;
            }

            for (const item of selectedItems) {
                for (const checkedOutUser of item.CheckoutUser) {
                    if (!CheckinCheckoutHelper.compareCurrentUser(checkedOutUser, userAccount.username)) {
                        return false;
                    }
                }
            }

            return true;
        };

        const hasSelection = selectedItems.length > 0;
        const hasEditableItems = !selectedItems.some(x => x?.EffectiveBasePermissions?.canEditListItem === false);
        const containsFiles = selectedItems.some(x => !x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder));

        const canOverrideCheckout =
            selectedItems.every(x => x.CheckoutUser) &&
            !selectedItems.some(x => x?.EffectiveBasePermissions?.canCancelCheckout === false);

        const shouldShowMenuItem =
            !isInOneDrive &&
            hasSelection &&
            hasEditableItems &&
            containsFiles &&
            (areAllItemsCheckedOutByCurrentUser() || canOverrideCheckout);

        if (shouldShowMenuItem) {
            return {
                key: 'checkin',
                disabled: waitFor === true,
                text: languageStrings.CheckIn,
                // iconProps: { iconName: "CheckedOutByOther12" },
                iconProps: {},
                onRenderIcon: () => <ArrowCircleUpLeft20Regular className={menuItemIconStyles} />,
                onClick: () => {
                    setIsPublish(false);
                    setShowCheckinDialog(true);
                }
            };
        }

        return null;

    }, [
        selectedItems,
        waitFor,
        isInOneDrive,
        userAccount.username,
        languageStrings,
        setIsPublish,
        setShowCheckinDialog
    ]);

    return {
        menuItem_Checkin
    };
}